import React from "react";
import { useTheme } from "../context/ThemeContext";

function AIAnalysis() {
  const { darkMode } = useTheme();

  return (
    <div
      className={`${
        darkMode ? "bg-gray-800" : "bg-white"
      } p-6 rounded-lg shadow-md`}
    >
      <div className="flex items-center justify-between mb-6">
        <h2
          className={`text-xl font-semibold ${
            darkMode ? "text-white" : "text-gray-800"
          } flex items-center gap-2`}
        >
          <span className="text-2xl">🤖</span> AI Analysis
        </h2>
        <span
          className={`px-3 py-1 rounded-full text-sm font-medium ${
            darkMode
              ? "bg-indigo-900/50 text-indigo-300"
              : "bg-indigo-100 text-indigo-700"
          }`}
        >
          Coming Soon
        </span>
      </div>

      <div
        className={`text-center py-8 ${
          darkMode ? "text-gray-400" : "text-gray-600"
        }`}
      >
        <p className="text-lg mb-2">
          AI-powered trade analysis feature is coming soon!
        </p>
        <p className="text-sm">
          Get detailed insights and personalized recommendations for your
          trading strategy.
        </p>
      </div>
    </div>
  );
}

export default AIAnalysis;
